import firebase from 'firebase/app'
import "firebase/auth";
import "firebase/firestore";
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyA86zvPToawZXPKSq2e6VcWgr9KC6BnycU",
    authDomain: "creativebuild-dev.firebaseapp.com",
    projectId: "creativebuild-dev",
    storageBucket: "creativebuild-dev.appspot.com",
    databaseURL: "https://creativebuild-dev-default-rtdb.firebaseio.com",
    messagingSenderId: "404127095855",
    appId: "1:404127095855:web:e6ebf088f0133ee56afada",
    measurementId: "G-3XTVT5TNV1"
  };

let FirebaseConfig = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.apps[0];

FirebaseConfig = FirebaseConfig.firebase_ ;
export default FirebaseConfig ;